import { useState, useCallback } from "react";

const useConfirmDelete = (onConfirm) => {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const requestDelete = useCallback((id) => {
    setDeleteId(id);
    setConfirmOpen(true);
  }, []);

  const handleConfirm = useCallback(() => {
    if (deleteId !== null) {
      onConfirm(deleteId);
    }
    setConfirmOpen(false);
    setDeleteId(null);
  }, [deleteId, onConfirm]);

  const handleCancel = useCallback(() => {
    setConfirmOpen(false);
    setDeleteId(null);
  }, []);

  return { confirmOpen, requestDelete, handleConfirm, handleCancel };
};

export default useConfirmDelete;
